import React from 'react';

const Grow = () => {
    return (
        <div className='bg-gray-500 py-16'>
            <h1 className='text-center font-bold text-3xl md:text-5xl text-white'>Grow your business globally with our fixed priced guarantee.No hidden costs, ever</h1>
            <p className='text-lg text-gray-100 text-center mt-10'>Check out our 100% transparent pricing</p>
        </div>
    );
};

export default Grow;